import { createAction } from 'redux-actions';
import { setFbbPlans, setBoosterPlans } from './constants';

export interface planList {
	payload: {
		availableCatalogEntryViews: types.ecommerce.CatalogEntryView[];
	};
}
export interface BoosterplanList {
	payload: {
		plans: types.ecommerce.BoosterPlans[];
	};
}
export const setAllFbbPlans: any = createAction(setFbbPlans, (plans: planList) => plans);
export const setBoosterFbbPlans: any = createAction(setBoosterPlans, (plans: BoosterplanList) => plans);

